import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-LightNew.woff2';
import woff from '../src/PPMori-LightNew.woff';

export const ppMoriLight: FontFaceSpec = {
  weight: 300,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
